import { Swiper } from 'swiper/bundle';

const swipers = document.querySelectorAll('.js-findings-swiper');

swipers.forEach((swiperInstance) => {
  initializeSwiper(swiperInstance);
});

function initializeSwiper(swiperInstance) {
  const slides = swiperInstance.querySelectorAll('.js-finding-slide');

  const swiper = new Swiper(swiperInstance, {
    watchOverflow: true,
    watchSlidesProgress: true,
    spaceBetween: 24,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next > button',
      prevEl: '.swiper-button-prev > button',
    },
    breakpoints: {
      0: {
        slidesOffsetAfter: 0,
        slidesPerView: 1.2,
      },
      768: {
        slidesOffsetAfter: -374,
        slidesPerView: 'auto',
      },
      1200: {
        slidesOffsetAfter: -748,
        slidesPerView: 'auto',
      },
    },
    a11y: {
      firstSlideMessage: 'Dit is de eerste slide',
      nextSlideMessage: 'Naar de volgende slide',
      prevSlideMessage: 'Naar de vorige slide',
      lastSlideMessage: 'Dit is de laatste slide',
      paginationBulletMessage: 'Ga naar slide {{index}}',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });

  slides.forEach((slide, index) => {
    slide.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });

  window.addEventListener('resize', () => {
    swiper.update();
  });
}

export { initializeSwiper };
